//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../no/Builder.js";
let d=[[[0,"AttributeHolder",0,"NXObject",0],[0,"DesignDescription",1,0],[0,"DesignName",1,0],[0,"DesignNumber",1,0],[0,"DesignRevision",1,0],[0,"Folder",1,0],[0,"Project",1,0],[0,"TemplatePart",1,0]],[[[],"AutoAssignDesignNumber",{},0,0],[[],"SynchronizeAttributes",{},0,0],[["templatePartContext"],"SetTemplatePartContext",{},1,0]],[]];
SPLM.CloudDM.NewPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CloudDM.NewPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.NewPartBuilder.TemplatePartContextinfo = class{
    constructor(collaborationSpaceId,containerId,containerType){
        this.collaborationSpaceId=collaborationSpaceId;this.containerId=containerId;this.containerType=containerType;}
    get Collaborationspaceid(){return this.collaborationSpaceId}
    set Collaborationspaceid(val){this.collaborationSpaceId = val}
    get Containerid(){return this.containerId}
    set Containerid(val){this.containerId = val}
    get Containertype(){return this.containerType}
    set Containertype(val){this.containerType = val}
};

export default SPLM;